import styled from '@emotion/styled';
import SwipeCard from '@components/Registration/Views/SwipeView/SwipeCard';
import React, {useEffect, useState} from 'react';
import SwipeController from '@components/Utils/SwipeController';
import {useBus} from 'react-bus';
import {MatchActionType} from '@models/MatchActionType';
import {useStore} from '@store/appStore';
import db from "@utils/db";
import moment from 'moment';


const mockEntries = Array(15).fill('');

export interface IProps {
    students:any;
}

export const SwipeDeck = (props:IProps) => {
    const [selectIndex, setSelectIndex] = useState<number>(0)
    const {setRegistrationIndex, schedule, scheduleIndex, setScheduleRegistration, client, setScreenType} = useStore();
    const bus = useBus();
    let temp = []
    const currentSchedule = schedule?.data ? schedule.data[scheduleIndex] : null;
    

    useEffect(() => {
        disableScroll();

        return () => {
            enableScroll();
        }
    }, [])

    props.students.data.map((s, index) => {
        temp.push(<SwipeCard key={index + s.username} student={s} />)
    })

    const confirmRegistration = async (isRegistered, force = false) => {
        const timeblockId = schedule?.data[scheduleIndex]?.id;
        const res = await db.Regi_MarkTimeBlockId(timeblockId, client.UserName, !isRegistered);
        if(!currentSchedule?.markregistered){
            let t = schedule.data.filter(s => !s.markregistered)
            let day = moment(schedule.data[scheduleIndex].date).isoWeekday();
            let type = 0;
            if(day === 5 && t.length === 1)type = 2;
            else if(t.length === 1)type = 1
            setScreenType({type:type, show:true})
        }
        if (res === 0) {
            setScheduleRegistration(!isRegistered);
        }
    };

    const onPick = (direction:string, button?:boolean):void => {
        let actionType:MatchActionType;
        if(!button){

            switch (direction) {
                case "left":
                    actionType = MatchActionType.MISSING;
                    bus.emit('onMatchNavAction', { actionType });
                if (currentSchedule?.markregistered)confirmRegistration(currentSchedule?.markregistered)
                    break;
                    case "right":
                        actionType = MatchActionType.ATTENDING;
                        bus.emit('onMatchNavAction', { actionType });
                        if (currentSchedule?.markregistered)confirmRegistration(currentSchedule?.markregistered)
                        break;
                        case "up":
                            actionType = MatchActionType.LATE;
                            bus.emit('onMatchNavAction', { actionType });
                            if (currentSchedule?.markregistered)confirmRegistration(currentSchedule?.markregistered)
                            break;
                        }
        }
        

        let newSelectIndex = direction === 'reset'? selectIndex - 1 :  selectIndex + 1;

        if(newSelectIndex > props.students.data.length - 1 || newSelectIndex < 0) {
            if(newSelectIndex > props.students.data.length - 1)
            {
                confirmRegistration(currentSchedule?.markregistered)
            }
                      
            setTimeout(() => {
                newSelectIndex = 0;
                setRegistrationIndex(newSelectIndex)
                setSelectIndex(newSelectIndex);
            }, 2000);
            return;
        }

        setSelectIndex(newSelectIndex);
    }

    const disableScroll = () => {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'scroll';
    };

    const enableScroll = () => {
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');

        var top = parseInt(document.body.style.top);
        if (top && top < 0) window.scrollTo(0, top * -1);
    };

    return (
        <ViewWrapper>
            <SwipeController onPick={onPick} index={selectIndex}>
                {temp}
            </SwipeController>
        </ViewWrapper>
    )
};

const ViewWrapper = styled.div`
    position: relative;
    width: 100%;
    min-height: calc(var(--site-height) - var(--header-height) - var(--regi-nav-height) + 20px);
`;

export default SwipeDeck;